import { Fragment, useState, useEffect, useRef } from 'react'
import { FormattedMessage } from 'react-intl'
import { buttons } from './schedule/ScheduleHeader'
import AdventureCard from '../adventures/AdventureCard'
import AdventureCardPlaceholder from '../adventures/AdventureCardPlaceholder'
import messages from './messages'
import API from 'api'
import './widget-activites.scss'
import Slider from 'react-slick'

const settings = {
  slidesToShow: 5,
  slidesToScroll: 5,
  infinite: false,
  arrows: false,
  dots: false,
  responsive: [
    { breakpoint: 481, settings: { slidesToShow: 4, slidesToScroll: 2 } },
    { breakpoint: 320, settings: { slidesToShow: 3.5, slidesToScroll: 2 } },
  ],
}

const Buttons = ({ onTypeChange, selectedType }) => {
  const slick = useRef(null)
  return (
    <Slider {...settings} ref={slick} className='widget-activities-selector'>
      {buttons.map((item, index) => {
        const onClick = () => {
          slick.current.slickGoTo(index - 1)
          onTypeChange(item.type)
        }
        return (
          <button
            id={`btn-${item.type}`}
            key={item.type}
            className={`widget-activities-selector__btn ${
              item.type === selectedType && 'active'
            }`}
            onClick={onClick}
          >
            <i className={`font-icons ${item.icon}`} /> {item.title}
          </button>
        )
      })}
    </Slider>
  )
}
const placeholderItems = [...new Array(window.innerWidth >= 1024 ? 4 : 3)]

const Adventures = ({ activites, selectedType }) => {
  if(!activites.length) {
    return (
      <div className='no-results'>
        <FormattedMessage {...messages[selectedType]} />
      </div>
    )
  }

  return activites.map((trip) => (
    <AdventureCard adventure={trip} key={trip.id} isWidget />
  ))
}

export default function WidgetActivites({ diveCenterId }) {
  const [selectedType, setSelectedType] = useState('all')
  const [activites, setActivities] = useState([])
  const [isLoading, setLoading] = useState(true)
  const onTypeChange = (type) => {
    setSelectedType(type)
  }

  useEffect(() => {
    let controller
    let signal

    setLoading(true)

    if('AbortController' in window) {
      controller = new window.AbortController()
      signal = controller.signal
    }

    API(
      `/api/adventure/v1/dive-centers/${diveCenterId}/${selectedType}/`,
      signal
    )
      .get({ uniq_activity: true })
      .then((items) => {
        setActivities(items.results)
        setLoading(false)
      })

    return () => controller && controller.abort()
  }, [selectedType])

  return (
    <Fragment>
      <Buttons onTypeChange={onTypeChange} selectedType={selectedType} />
      <div
        className={`actitivities-container ${
          isLoading ? 'placeholder-animation' : ''
        }`}
      >
        {isLoading ? (
          placeholderItems.map((_, i) => {
            return <AdventureCardPlaceholder key={i} />
          })
        ) : (
          <Adventures activites={activites} selectedType={selectedType} />
        )}
      </div>
    </Fragment>
  )
}
